<div class="complete-umbrueckung-dialog">

  <div class="dialog-layout">
    <h2 class="dialog-h2">
      {{'swap trailer' | translate: ['tmc.complete-umbrueckung-dialog.title', translationService.language]}}
    </h2>
    <i class="horizontal-divider"></i>

    <div class="top-info">
      <app-transport-info-panel [carrier]="details.carrier" [identifier]="details.identifier" [driver]="details.name"
        [scope]="details.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content">
      <div [innerHTML]="'the trailer of the selected transport of currently beeing swapped, you can cancel or complete this process.' | translate: ['tmc.complete-umbrueckung-dialog.info-text', translationService.language] |
        trustHtml">
      </div>

      <div class="messages">
        <app-service-response [responseMessages]="responseMessages"></app-service-response>
      </div>

    </div>

    <i class="horizontal-divider"></i>

    <sc-actionbar>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button class="cancel-button" (click)="closeDialog()">{{'cancel' |
        translate:['tmc.complete-umbrueckung-dialog.action.cancel', translationService.language]}}
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button class="" mat-stroked-button (click)="cancel()"
        [matTooltip]="'cancel swap trailer' | translate:['tmc.complete-umbrueckung-dialog.action.cancel-swap', translationService.language]">
        {{'cancel swap trailer' | translate:['tmc.complete-umbrueckung-dialog.action.cancel-swap',
        translationService.language]}}
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button class="confirm-button" mat-flat-button (click)="complete()"
        [matTooltip]="'complete swap trailer' | translate:['tmc.complete-umbrueckung-dialog.action.complete', translationService.language]">
        {{'complete swap trailer' | translate:['tmc.complete-umbrueckung-dialog.action.complete',
        translationService.language]}}
      </button>
    </sc-actionbar>
  </div>
</div>